import React, { useState, useEffect } from 'react';
import api from '../services/api';
import Button from './Button/Button';
import Select from './Select/Select';
import Input from './Input/Input';

function Skills({ skills, skillGroups, reloadAll }) {
  const [editingSkill, setEditingSkill] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [selectedDepartmentId, setSelectedDepartmentId] = useState('');
  const [filteredSkillGroups, setFilteredSkillGroups] = useState(skillGroups);

  // Load departments on mount
  useEffect(() => {
    const loadDepartments = async () => {
      try {
        const res = await api.getDepartments();
        setDepartments(res.data);
        if (res.data.length > 0) {
          setSelectedDepartmentId(res.data[0].id);
        }
      } catch (error) {
        console.error('Error loading departments:', error);
      }
    };

    loadDepartments();
  }, []);

  // Filter skill groups based on selected department
  useEffect(() => {
    if (selectedDepartmentId) {
      const filtered = skillGroups.filter(group => group.department_id === parseInt(selectedDepartmentId));
      setFilteredSkillGroups(filtered);
    } else {
      setFilteredSkillGroups(skillGroups);
    }
  }, [selectedDepartmentId, skillGroups]);

  const handleUpdateSkill = async (e) => {
    e.preventDefault();
    try {
      await api.updateSkill(editingSkill.id, editingSkill);
      setEditingSkill(null);
      reloadAll();
    } catch (error) {
      console.error('Error updating skill:', error);
    }
  };

  const handleDeleteSkill = async (id) => {
    if (window.confirm('Are you sure you want to delete this skill?')) {
      try {
        await api.deleteSkill(id);
        reloadAll();
      } catch (error) {
        console.error('Error deleting skill:', error);
      }
    }
  };

  // Transform skill groups for Select component
  const skillGroupOptions = filteredSkillGroups.map(group => ({
    value: group.id,
    label: group.title
  }));

  // Transform departments for Select component
  const departmentOptions = departments.map(dept => ({
    value: dept.id,
    label: dept.name
  }));

  // Filter skills based on selected department
  const filteredSkills = selectedDepartmentId
    ? skills.filter(skill => skill.department_id === parseInt(selectedDepartmentId))
    : skills;

  return (
    <div>
      <div className="form-group mb-4">
        <label>Filter by Department</label>
        <Select
          options={departmentOptions}
          showSearch={false}
          value={selectedDepartmentId}
          onChange={(value) => setSelectedDepartmentId(value)}
          placeholder="Select a department"
          id="department-filter"
        />
      </div>

      <div className="table-scroll-wrapper table-scroll-wrapper--inline">
        <table className="table">
          <thead>
            <tr>
              <th>Title</th>
              <th>Skill Group</th>
              <th>Department</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredSkills.map((skill) => (
              <tr key={skill.id}>
                <td>
                  {editingSkill?.id === skill.id ? (
                    <Input
                      type="text"
                      value={editingSkill.title}
                      onChange={(e) => setEditingSkill({ ...editingSkill, title: e.target.value })}
                      id={`edit-skill-title-${skill.id}`}
                    />
                  ) : (
                    skill.title
                  )}
                </td>
                <td>
                  {editingSkill?.id === skill.id ? (
                    <Select
                      options={skillGroupOptions}
                      value={editingSkill.skill_group_id || ''}
                      onChange={(value) => setEditingSkill({ ...editingSkill, skill_group_id: value })}
                      placeholder="Select a skill group"
                      id={`edit-skill-group-${skill.id}`}
                    />
                  ) : (
                    skillGroups.find((g) => g.id === skill.skill_group_id)?.title || '-'
                  )}
                </td>
                <td>
                  {editingSkill?.id === skill.id ? (
                    <Select
                      options={departmentOptions}
                      value={editingSkill.department_id || ''}
                      onChange={(value) => setEditingSkill({ ...editingSkill, department_id: value })}
                      placeholder="Select a department"
                      id={`edit-skill-department-${skill.id}`}
                    />
                  ) : (
                    departments.find((d) => d.id === skill.department_id)?.name || '-'
                  )}
                </td>
                <td className="td--actions">
                  {editingSkill?.id === skill.id ? (
                    <>
                      <Button type="primary" onClick={handleUpdateSkill}>Save</Button>
                      <Button type="secondary" onClick={() => setEditingSkill(null)}>Cancel</Button>
                    </>
                  ) : (
                    <>
                      <Button type="secondary" onClick={() => setEditingSkill(skill)}>Edit</Button>
                      <Button type="destructive" onClick={() => handleDeleteSkill(skill.id)}>Delete</Button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </div>
  );
}

export default Skills; 